"use strict";
/*
 * Created on 04 09 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutSourceImpactValuesConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutSourceImpactValuesConverter, _DataObjectConverter_);

  function SelloutSourceImpactValuesConverter() {
    _classCallCheck(this, SelloutSourceImpactValuesConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutSourceImpactValuesConverter).apply(this, arguments));
  }

  return SelloutSourceImpactValuesConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutSourceImpactValuesConverter = SelloutSourceImpactValuesConverter;